import { useEffect } from 'react';

function useTitle(title = 'Appcues') {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = 'Appcues';
    };
  }, [title]);
}

export default useTitle;
